import shareEmail from 'assets/img/share_email.svg';
import shareWhatsApp from 'assets/img/share_whatsapp.svg';
import shareTwitter from 'assets/img/share_twitter.svg';
import shareFacebookIcon from 'assets/img/share_facebook.svg';

import shareEmailRSPV from 'assets/img/share_email_rspv.png';
import shareWhatsAppRSPV from 'assets/img/share_whatsapp_rspv.png';
import shareTwitterRSPV from 'assets/img/share_twitter_rspv.png';
import shareFacebookIconRSPV from 'assets/img/share_facebook_rspv.png';

let whatsappProtocol
if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator?.userAgent)){
  whatsappProtocol = 'https://wa.me/'
}else{
  whatsappProtocol = 'whatsapp://send'
}

export const SHARE_LINKS = [
  {
    id: 'email',
    alt: 'Compartir por correo electrónico',
    icon: shareEmail,
    getLink: (url) =>
      `mailto:tuinvitado@mail.com?subject=Mesa de regalos&body=Hola!%20Te comparto mi mesa de regalos: ${url}`,
  },
  {
    id: 'whatsapp',
    alt: 'Compartir en WhatsApp',
    icon: shareWhatsApp,
    getLink: (url) =>
      `${whatsappProtocol}?text=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29%20${url}`,
  },
  {
    id: 'twitter',
    alt: 'Compartir en Twitter',
    icon: shareTwitter,
    getLink: (url) =>
      `https://twitter.com/intent/tweet?text=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29&url=${url}`,
  },
  {
    id: 'facebook',
    alt: 'Compartir en Facebook',
    icon: shareFacebookIcon,
    getLink: (url) => `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29`,
  },
];

export const SHARE_LINKS_TABLE = [
  {
    id: 'facebook',
    alt: 'Compartir en Facebook',
    icon: shareFacebookIconRSPV,
    getLink: (url) => `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29`,
  },
  {
    id: 'email',
    alt: 'Compartir por correo electrónico',
    icon: shareEmailRSPV,
    getLink: (url) =>
      `mailto:tuinvitado@mail.com?subject=Mesa de regalos&body=Hola!%20Te comparto mi invitacion: ${url}`,
  },
  {
    id: 'whatsapp',
    alt: 'Compartir en WhatsApp',
    icon: shareWhatsAppRSPV,
    getLink: (url) =>
      `whatsapp://send?text=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29%20${url}`,
  },
  {
    id: 'twitter',
    alt: 'Compartir en Twitter',
    icon: shareTwitterRSPV,
    getLink: (url) =>
      `https://twitter.com/intent/tweet?text=Hola%21%20Les%20dejo%20mi%20mesa%20de%20regalos%20%3A%29&url=${url}`,
  },
];

